import { render, staticRenderFns } from "./edit_asset.vue?vue&type=template&id=1b4bc8c0&scoped=true"
import script from "./edit_asset.vue?vue&type=script&lang=js"
export * from "./edit_asset.vue?vue&type=script&lang=js"
import style0 from "./edit_asset.vue?vue&type=style&index=0&id=1b4bc8c0&prod&lang=css&scoped=true"
import style1 from "./edit_asset.vue?vue&type=style&index=1&id=1b4bc8c0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b4bc8c0",
  null
  
)

export default component.exports